(function () {
  if (window.__dzInit) return;
  window.__dzInit = true;
  var d = document;
  d.documentElement.classList.add('dz-js');
  function init() {
    var els = d.querySelectorAll('.dz-reveal:not(.is-in)');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init);
  else init();
  d.addEventListener('shopify:section:load', init);
})();
